import type { i18n as I18nInstance } from 'i18next';

const efficiencyUnitTranslationKeys: Record<string, string> = {
  mpg: 'mpg',
  'l/100km': 'l100km',
  'kWh/100km': 'kwhBy100km',
};

export default function formatVehicleEfficiencyUnit(
  i18n: I18nInstance,
  efficiencyUnit: string | null | undefined,
): string {
  if (!efficiencyUnit) {
    return '';
  }
  const translationKey = efficiencyUnitTranslationKeys[efficiencyUnit];
  if (!translationKey) {
    return efficiencyUnit;
  }
  return i18n.t(`business:emissionFactors.efficiency.${translationKey}`, efficiencyUnit);
}
